import {Result} from '../../resultModel'
import {
  APPOINTMENTDETAILS_BY_ID_GETURL,
  APPOINTMENTDETAILS_CREATE_APPOINTMENTDETAILS_POSTURL,
  APPOINTMENTDETAILS_SAVE_APPOINTMENTDETAILS_POSTURL,
  APPOINTMENTDETAILS_UPDATE_PUTURL
} from '../../endpoints'
import {RequestManager} from '../../RequestManager'
import { GetAppointmentDetailsOutput } from './models/GetAppointmentDetailsModels'
import { SaveAppointmentDetailsInput } from './models/SaveAppointmentDetailsModels'

export const getAppointmentDetailsByAppointmentId = async (appointmentId: number) => {
  const requestManager = new RequestManager()

  var res: Result<GetAppointmentDetailsOutput> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<GetAppointmentDetailsOutput>>(APPOINTMENTDETAILS_BY_ID_GETURL(appointmentId))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

  export const saveAppointmentDetails = async (input: SaveAppointmentDetailsInput) => {
    const requestManager = new RequestManager()
  
    var res: Result<string> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .post<Result<string>>(APPOINTMENTDETAILS_SAVE_APPOINTMENTDETAILS_POSTURL, input)
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }

